import moment from 'moment'
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useDateTimeStore = defineStore('dateTime', () => {
  const date = ref<string>('') // dd-mm-yyyy
  const time = ref<string>('00:00') // hh:mm
  const isLive = ref<boolean>(true)

  const haltPlayButton = ref<boolean>(false)

  const dateTime = ref<Date | null>(null)

  const resetCounter = ref<number>(0)
  const updateCounter = ref<number>(0)

  watch([date, time, isLive], ([newDate, newTime, newIsLive]) => {
    if (newIsLive) {
      dateTime.value = null
      return
    }

    const dts = newDate + ' ' + newTime
    const dt = moment(dts, 'YYYY-MM-DD hh:mm').utc().toDate()
    dateTime.value = dt
  })

  setFormattedDate(new Date())

  function setDate(newDate: string) {
    if (newDate === null) {
      return
    }
    date.value = newDate
  }

  function setTime(newTime: string) {
    time.value = newTime
  }

  function setIsLive(newValue: boolean) {
    isLive.value = newValue
  }

  function incrementTime() {
    if (!dateTime.value) {
      return
    }

    const newDateTime = moment(dateTime.value).add(10, 'minutes').toDate()
    const dateNow = moment().utc().toDate()

    if (newDateTime >= dateNow) {
      haltPlayButton.value = true
    }

    setDateTime(newDateTime)
  }

  function setDateTime(dateTime: Date) {
    setFormattedDate(dateTime)
    setFormattedTime(dateTime)
  }

  function setFormattedDate(dateTime: Date) {
    const day = String(dateTime.getDate()).padStart(2, '0')
    const month = String(dateTime.getMonth() + 1).padStart(2, '0')
    const year = dateTime.getFullYear()

    const formattedDate = `${year}-${month}-${day}`

    setDate(formattedDate)
  }

  function setFormattedTime(dateTime: Date) {
    const hours = String(dateTime.getHours()).padStart(2, '0')
    const minutes = String(dateTime.getMinutes()).padStart(2, '0')
    const formattedTime = `${hours}:${minutes}`

    setTime(formattedTime)
  }

  function reset() {
    resetCounter.value += 1
  }

  function update() {
    updateCounter.value += 1
  }

  function updateHalting(newVal: boolean) {
    haltPlayButton.value = newVal
  }

  return {
    date,
    time,
    isLive,
    dateTime,
    resetCounter,
    haltPlayButton,
    updateCounter,
    reset,
    update,
    incrementTime,
    setIsLive,
    setDate,
    setTime,
    setDateTime,
    setFormattedDate,
    setFormattedTime,
    updateHalting
  }
})
